export interface TimerObject {
    timer?: number;
}

// 倒计时方法, 会对时间误差做修正
export function countdownFunc(countdown: number, interval: number, callback: () => void, endCallback?: () => void) {
    let count = 0;
    let curCountdown = (countdown + 1) * 1000;
    let result: TimerObject = {};
    const startTime = Date.now();
    const curInterval = interval * 1000;

    async function countdownHelper() {
        const offset = Date.now() - (startTime + count * curInterval);
        let nextInterval = curInterval - offset;

        if (nextInterval < 0) {
            nextInterval = 0;
        }

        curCountdown -= curInterval;

        if (curCountdown <= 0) {
            await endCallback?.();
            clearTimeout(result.timer);
        } else {
            count++;

            result.timer = window.setTimeout(async () => {
                await callback();
                countdownHelper();
            }, nextInterval);
        }
    }

    countdownHelper();

    return result;
}
